import { render } from "./TransferInfo.vue?vue&type=template&id=7c2c0f26&scoped=true"
import script from "./TransferInfo.vue?vue&type=script&lang=js"
export * from "./TransferInfo.vue?vue&type=script&lang=js"

import "./TransferInfo.vue?vue&type=style&index=0&id=7c2c0f26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2c0f26"]])

export default __exports__